import { Action, ActionType } from "app/pages/Products/actionTypes";
import { AccommodationProduct, AccommodationTypeValue, AddOnsProduct, CourseIntensityDto, CourseProduct,Fee,CancellationFee,PackageProduct,ProductCategory,ProductDivision,TransferPort,TransferType,TransfersProduct, UnitType,AccountCategory, CommissionCategory, Languages } from "app/shared/model";
import { Product } from "app/shared/model/ProductBase";
import { FormError } from "app/shared/model/Form";

export function pageLoaded(courseIntensity: CourseIntensityDto[], productDivisions: ProductDivision[], accommodationTypes: AccommodationTypeValue[], unitTypes: UnitType[], transferTypes: TransferType[], transferPorts: TransferPort[], productCategories: ProductCategory[], accountCategories: AccountCategory[], languages: Languages[], commissionCategories: CommissionCategory[] = [] ) : Action {
    return {        
        type: ActionType.PageLaded,
        courseIntensity:courseIntensity,
        productDivisions:productDivisions,
        accommodationTypes:accommodationTypes,
        unitTypes:unitTypes,
        transferTypes:transferTypes,
        transferPorts:transferPorts,
        productCategories: productCategories,
        accountCategories: accountCategories,
        commissionCategories,
        languages:languages,
        formErrors: [],
    };
}

export function changeSearchTerm(searchTerm: string) : Action {
    return {
        type: ActionType.ChangeSearchTerm,
        searchTerm: searchTerm
    }
}

export function changeSelectedProductType(selectedProductType: string, changed: boolean): Action {
    return {
        type: ActionType.ChangeSelectedProductType,
        selectedProductType: selectedProductType,
        tabChanged: changed
    }
}

export const filterData = (
  filteredData?: (Product | Fee | CancellationFee | TransfersProduct)[]
) => ({
  type: ActionType.FilterData,
  filteredData,
});

export function listAccommodationProductsData(data: AccommodationProduct[]): Action  {
    return {
        type: ActionType.ListAccommodationProductsData,
        accommodationProducts: data
    }
}

export function listCourseProductsData(data: CourseProduct[]): Action  {
    return {
        type: ActionType.ListCoursesData,
        courseProducts: data
    }
}

export function getCourseProductById(data: CourseProduct): Action  {
    return {        
        type: ActionType.GetCourseProductData,
        courseProduct: data
    }
}

export function getAccommodationProductById(data: AccommodationProduct | undefined): Action  {
    return {        
        type: ActionType.GetAccommodationProduct,
        accommodation: data
    }
}

export function getTransferProductById(data: TransfersProduct): Action  {
    return {        
        type: ActionType.GetTransferProduct,
        transfer: data
    }
}

export function getAddonProductById(data: AddOnsProduct): Action  {
    return {        
        type: ActionType.GetAddonProduct,
        addon: data
    }
}

export function listAddOnsProductsData(data: AddOnsProduct[]): Action  {
    return {
        type: ActionType.ListAddOns,
        addOnsProducts: data
    }
}

export function listTransferssProductsData(data: TransfersProduct[]): Action  {
    return {
        type: ActionType.ListTransfers,
        transferProducts:data
    }
}

export function listPackageProductsData(data: PackageProduct[]): Action  {
    return {
        type: ActionType.ListPackages,
        packageProducts: data
    }
}
export const listFeesProductsData = (feesProducts: Fee[]) => ({
    type: ActionType.ListFees,
    feesProducts
});

export const listCancellationFeesProductsData = (cancellationFeeProducts: CancellationFee[]) => ({
    type: ActionType.ListCancellationFees,
    cancellationFeeProducts
});

export function getCancellationFeeProductById(data: CancellationFee | undefined) {
    return {
        type: ActionType.GetCancellationFeeProduct,
        cancellationFee: data
    };
}

export function resetCancellationFeeModal() {
    return {
        type: ActionType.CancelShowDeleteCancellationFeeAction
    };
}

export function UpdateDraftCancellationFeeProduct(draftProduct: CancellationFee | undefined) {
    return {
        type: ActionType.UpdateDraftCancellationFeeProduct,
        draftProduct
    };
}

export function loadDraftCancellationFeeProduct(draftProduct: CancellationFee | undefined) {
    return {
        type: ActionType.LoadDraftCancellationFeeProduct,
        draftProduct
    };
}

export function UpdateDraftFeeProduct(feeProduct: Fee | undefined) {
    return {
        type: ActionType.UpdateDraftFeeProduct,
        draftProduct: feeProduct,
    };
}

export function loadDraftFeeProduct(draftProduct: Fee | undefined) {
    return {
        type: ActionType.LoadDraftFeeProduct,
        draftProduct: draftProduct,
    };
}
export function getDraftFeeProduct(data: Fee): Action {
    return {
        type: ActionType.GetFeeProduct,
        fee: data
    };
}

export function getFeeProductById(data: Fee | undefined): Action  {
    return {
        type: ActionType.GetFeeProduct,
        fee: data
    };
}

export function getPackageProductById(data: PackageProduct): Action  {
    return {
        type: ActionType.GetPackageProduct,
        packageProduct: data
    }
}

export function setCourseProductName(data: string): Action  {
    return {        
        type: ActionType.SetCourseProductName,
        name: data
    }
}

export function getCourseProductName(data: string): Action  {
    return {        
        type: ActionType.GetCourseProductName,
        name: data
    }
}

export function setCourseProductIntensity(data: number): Action  {
    return {        
        type: ActionType.SetCourseProductIntensity,
        id: data
    }
}

export function setCourseDivision(data: number): Action  {
    return {        
        type: ActionType.SetCourseDivision,
        id: data
    }
}

export function resetCourseModal() : Action {
    return {
        type: ActionType.CancelShowDeleteCourseAction
    };
}

export function resetAccommodationModal() : Action {
    return {
        type: ActionType.CancelShowDeleteAccommodationAction
    };
}

export function UpdateDraftAccommodationProduct(accommodationProduct: AccommodationProduct)
{
    return {
        type: ActionType.UpdateDraftAccommodationProduct,
        draftProduct: accommodationProduct,
    }
}

export function loadDraftAccommodationProduct(draftProduct: AccommodationProduct)
{
    return {
        type: ActionType.LoadDraftAccommodationProduct,
        draftProduct: draftProduct,
    }
}

export function resetAddOnModal() : Action {
    return {
        type: ActionType.CancelShowDeleteAddOnAction
    };
}
export function resetFeeModal() : Action {
    return {
        type: ActionType.CancelShowDeleteFeeAction
    };
}

export function resetTransferModal() : Action {
    return {
        type: ActionType.CancelShowDeleteTransferAction
    };
}

export function resetPackageModal() : Action {
    return {
        type: ActionType.CancelShowDeletePackageAction
    };
}

export function UpdateDraftAddOnProduct(addOnProduct: AddOnsProduct)
{
    return {
        type: ActionType.UpdateDraftAddOnProduct,
        draftProduct: addOnProduct,
    }
}

export function loadDraftAddOnProduct(draftProduct: AddOnsProduct)
{

    return {
        type: ActionType.LoadDraftAddOnProduct,
        draftProduct: draftProduct,
    }
}

export function UpdateDraftTransferProduct(transferProduct: TransfersProduct)
{
    return {
        type: ActionType.UpdateDraftTransferProduct,
        draftProduct: transferProduct,
    }
}

export function loadDraftTransferProduct(draftProduct: TransfersProduct)
{
    return {
        type: ActionType.LoadDraftTransferProduct,
        draftProduct: draftProduct,
    }
}

export function UpdateDraftPackageProduct(packageProduct: PackageProduct)
{
    return {
        type: ActionType.UpdateDraftPackageProduct,
        draftProduct: packageProduct,
    }
}

export function loadDraftPackageProduct(draftProduct: PackageProduct)
{
    return {
        type: ActionType.LoadDraftPackageProduct,
        draftProduct: draftProduct,
    }
}

export function setFormErrors(formErrors: FormError[])
{
    return {
        type: ActionType.SetFormErrors,
        formErrors: formErrors
    }
}

export function resetFormErrors()
{
    return {
        type: ActionType.SetFormErrors,
        formErrors: []
    }
}